import { render } from "./NameComponent.vue?vue&type=template&id=e9ee24f4"
import script from "./NameComponent.vue?vue&type=script&lang=js"
export * from "./NameComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__